const req = require.context('./', true, /_\w*\.js$/);

const constants = {};

req.keys().forEach((key) => {
    constants[key.replace(/^\.\/_(\w*)\.js$/, "$1")] = req(key).default;
});
export default constants;

